let Constants = {
    API_ENDPOINT: "https://api-kids2019.mulinobianco.it",
    API_TOKEN: "5fa71b63-af8f-11e9-943d-fa163e160333",
    PROMO_CODE: "kids2019",
    CH_PROMO: "CH_308_MLB_KIDS19_CRS_CRS_20190821_20191201"
}

export default Constants;
